import { useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { handleCreateTalks } from './api';
import { TalksRequest } from './types';

export function useTalks() {
  const { locationId, agentId } = useParams<{
    locationId: string;
    agentId: string;
    actionId: string;
  }>();

  return useMutation({
    mutationFn: (payload: TalksRequest) => handleCreateTalks(locationId!, agentId!, payload)
  });
}
